module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "padding": "0"
    }
  }, [_c('tr', {
    staticStyle: {
      "padding": "0"
    }
  }, _vm._l((_vm.features), function(value, key) {
    return _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ({
          html: _vm.compound[key] ? value.textValidCompound : value.textInvalidCompound
        }),
        expression: "{ html: compound[key] ? value.textValidCompound : value.textInvalidCompound }",
        arg: "top"
      }],
      key: key,
      style: ({
        'text-align': 'center',
        cursor: 'pointer'
      })
    }, [_c('img', {
      staticStyle: {
        "width": "30%",
        "max-width": "50px",
        "padding": "10px 0 0 0"
      },
      attrs: {
        "src": _vm.compound[key] ? value.imageValid : value.imageInvalid
      }
    })])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.features), function(value, key) {
    return _c('td', {
      key: key,
      style: ({
        'text-align': 'center',
        color: 'gray',
        background: _vm.compound[key] ? '#C8E6C9' : '#FFCDD2',
        'border-bottom': _vm.compound[key] ? '5px solid #66BB6A' : '5px solid #EF5350'
      })
    })
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d86d8f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-compound/prb-compound-top/prb-features/PrbFeatures.vue
// module id = 552
// module chunks = 1